import { create } from "zustand";
import { rewardsApi ,addRewardsApi ,afterAddRewardsApi ,syncBalanceApi } from "../api_layer/api";
import { toast } from 'react-toastify';

const useRewardDataStore = create((set) => ({
  rewardsData: [],
  rewardsLoading: false,
  error: null,
  addRewardData:[],
  addRewardDataLoading: false,
  addRewardDataError: null,
  afterAddRewardData:[],
  afterAddRewardLoading: false,
  afterAddRewardError: null,
  syncBalanceData:{},
  syncBalanceLoading: false,
  syncBalanceError: null,
  fetRewardsData: async (caseId, year, month) => {
    try {
      set({ rewardsLoading: true, error: null });
      const response = await rewardsApi(caseId, year, month);
      set({ rewardsData: response.data, rewardsLoading: false });
    } catch (error) {
      set({ error: error.message, rewardsLoading: false });
    }
  },
  fetchAddRewardsData: async () => {
    try {
      set({ afterAddRewardLoading: true, addRewardDataError: null });
      const response = await addRewardsApi();
      set({ addRewardData: response.data, addRewardDataLoading: false });
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while adding rewards';
      set({ addRewardDataError: errorMessage, addRewardDataLoading: false });
      toast.error(errorMessage);
    }
  },
  fetchAfterAddRewardsData: async (id,data) => {
    try {
      set({ afterAddRewardLoading: true, afterAddRewardError: null });
      const response = await afterAddRewardsApi(id,data);
      toast.success(response?.data?.message || 'Rewards added successfully');
      set({  afterAddRewardData: response.data,   afterAddRewardLoading: false });
    } catch (error) {
      const errorMessage = error?.response?.data?.err?.message || error?.message || 'An error occurred';
      set({   afterAddRewardError: errorMessage,    afterAddRewardLoading: false });
      toast.error(errorMessage);
    }
  },
  fetchSyncBalanceData: async (id) => {
    try {
      set({ syncBalanceLoading: true, afterAddRewardError: null });
      const response = await  syncBalanceApi(id);
      toast.success(response?.data.message);
      set({  syncBalanceData: response?.data.message,   syncBalanceLoading: false });
    } catch (error) {
      const errorMessage = error?.response?.data?.err.message || error?.message || 'An error occurred';
      set({   afterAddRewardError: errorMessage,    syncBalanceLoading: false });
      toast.error(errorMessage);
    }
  },
}));

export default useRewardDataStore;